// extracted by mini-css-extract-plugin
module.exports = {"name":"ArchitectNotEnabledPopup_name__2sPWm","description":"ArchitectNotEnabledPopup_description__229eT"};